module.exports = __webpack_public_path__ + "img/shangjiafuwu.ae2f18b7.jpg";